import { Music, Globe, Film } from 'lucide-react';
import type {
  ActivityEntry,
  ConnectedAccount,
  PortfolioEntity,
  Transaction,
} from '@/types/portfolio.types';

export const portfolioEntities: PortfolioEntity[] = [
  {
    id: 'dj-pe-1',
    name: 'Coco Jones',
    type: 'artist',
    icon: Music,
    activeDeals: 2,
    totalValue: '$2.5M',
    color: 'text-violet-500',
    bgClass: 'bg-violet-500/15',
    activeBg: 'bg-violet-500/15 ring-violet-500/40',
  },
  {
    id: 'dj-pe-2',
    name: 'Justin Bieber',
    type: 'artist',
    icon: Music,
    activeDeals: 1,
    totalValue: '$12M',
    color: 'text-amber-500',
    bgClass: 'bg-amber-500/15',
    activeBg: 'bg-amber-500/15 ring-amber-500/40',
  },
  {
    id: 'dj-pe-3',
    name: 'Sync & Licensing',
    type: 'brand',
    icon: Film,
    activeDeals: 2,
    totalValue: '$900K',
    color: 'text-red-500',
    bgClass: 'bg-red-500/15',
    activeBg: 'bg-red-500/15 ring-red-500/40',
  },
  {
    id: 'dj-pe-4',
    name: 'Nasty C JV',
    type: 'ip',
    icon: Globe,
    activeDeals: 1,
    totalValue: '$3M',
    color: 'text-cyan-500',
    bgClass: 'bg-cyan-500/15',
    activeBg: 'bg-cyan-500/15 ring-cyan-500/40',
  },
];

export const ENTITY_DEAL_MAP: Record<string, string[]> = {
  'dj-pe-1': ['dj-deal-1', 'dj-deal-9'],
  'dj-pe-2': ['dj-deal-2'],
  'dj-pe-3': ['dj-deal-6'],
  'dj-pe-4': ['dj-deal-5'],
};

export const ENTITY_TRANSACTIONS: Record<string, Transaction[]> = {
  'dj-pe-1': [
    { id: 'dj-t-1', title: 'Recording Advance (Installment 1)', dealName: 'Coco Jones - Recording Agreement', amount: 833333, direction: 'out', status: 'completed', date: 'Feb 1, 2026', counterparty: 'Coco Jones', isoDate: '2026-02-01', category: 'advance', dealId: 'dj-deal-1', method: 'wire' },
    { id: 'dj-t-2', title: 'Q4 Streaming Royalties', dealName: 'Coco Jones - Recording Agreement', amount: 45000, direction: 'in', status: 'completed', date: 'Jan 30, 2026', counterparty: 'UMG Distribution', isoDate: '2026-01-30', category: 'royalties', dealId: 'dj-deal-1', method: 'ach' },
    { id: 'dj-t-3', title: 'Touring Revenue Share', dealName: 'Coco Jones - Recording Agreement', amount: 62000, direction: 'in', status: 'scheduled', date: 'Apr 15, 2026', counterparty: 'Kith', isoDate: '2026-04-15', category: 'royalties', dealId: 'dj-deal-1', method: 'wire' },
    { id: 'dj-t-4', title: 'Merch License Payment', dealName: 'Alessia Cara - Merch License', amount: 50000, direction: 'in', status: 'pending', date: 'Apr 1, 2026', counterparty: 'Merch Co', isoDate: '2026-04-01', category: 'brand_fee', dealId: 'dj-deal-9', method: 'ach' },
    { id: 'dj-t-20', title: 'Studio Production Costs', dealName: 'Coco Jones - Recording Agreement', amount: 85000, direction: 'out', status: 'completed', date: 'Feb 15, 2026', counterparty: 'Quad Studios NYC', isoDate: '2026-02-15', category: 'production', dealId: 'dj-deal-1', method: 'check' },
    { id: 'dj-t-21', title: 'Q3 Streaming Royalties', dealName: 'Coco Jones - Recording Agreement', amount: 38000, direction: 'in', status: 'completed', date: 'Oct 30, 2025', counterparty: 'UMG Distribution', isoDate: '2025-10-30', category: 'royalties', dealId: 'dj-deal-1', method: 'ach' },
    { id: 'dj-t-22', title: 'Marketing Campaign', dealName: 'Coco Jones - Recording Agreement', amount: 25000, direction: 'out', status: 'completed', date: 'Nov 15, 2025', counterparty: 'Digital Promo Agency', isoDate: '2025-11-15', category: 'marketing', dealId: 'dj-deal-1', method: 'ach' },
  ],
  'dj-pe-2': [
    { id: 'dj-t-5', title: 'Album 7 Advance (Installment 1)', dealName: 'Justin Bieber - Album 7 Amendment', amount: 4000000, direction: 'out', status: 'pending', date: 'Apr 1, 2026', counterparty: 'ILH Production Co', isoDate: '2026-04-01', category: 'advance', dealId: 'dj-deal-2', method: 'wire' },
    { id: 'dj-t-6', title: 'Bieber Catalog Royalties Q4', dealName: 'Justin Bieber - Album 7 Amendment', amount: 1200000, direction: 'in', status: 'completed', date: 'Jan 15, 2026', counterparty: 'UMG Distribution', isoDate: '2026-01-15', category: 'royalties', dealId: 'dj-deal-2', method: 'wire' },
    { id: 'dj-t-23', title: 'Bieber Catalog Royalties Q3', dealName: 'Justin Bieber - Album 7 Amendment', amount: 1100000, direction: 'in', status: 'completed', date: 'Oct 15, 2025', counterparty: 'UMG Distribution', isoDate: '2025-10-15', category: 'royalties', dealId: 'dj-deal-2', method: 'wire' },
    { id: 'dj-t-24', title: 'Album 7 Production Budget', dealName: 'Justin Bieber - Album 7 Amendment', amount: 500000, direction: 'out', status: 'scheduled', date: 'May 1, 2026', counterparty: 'Various Producers', isoDate: '2026-05-01', category: 'production', dealId: 'dj-deal-2', method: 'wire' },
  ],
  'dj-pe-3': [
    { id: 'dj-t-7', title: 'Nike Sync License Fee', dealName: '2 Chainz - Nike Sync License', amount: 375000, direction: 'in', status: 'pending', date: 'May 1, 2026', counterparty: 'Nike', isoDate: '2026-05-01', category: 'sync_fee', dealId: 'dj-deal-6', method: 'wire' },
    { id: 'dj-t-25', title: 'Music Supervisor Fee', dealName: '2 Chainz - Nike Sync License', amount: 15000, direction: 'out', status: 'completed', date: 'Mar 10, 2026', counterparty: 'Sync Agency', isoDate: '2026-03-10', category: 'talent', dealId: 'dj-deal-6', method: 'ach' },
  ],
  'dj-pe-4': [
    { id: 'dj-t-9', title: 'JV Initial Capitalization', dealName: 'Nasty C JV', amount: 1000000, direction: 'out', status: 'completed', date: 'Jan 15, 2026', counterparty: 'Nasty C JV', isoDate: '2026-01-15', category: 'investment', dealId: 'dj-deal-5', method: 'wire' },
    { id: 'dj-t-10', title: 'JV Phase 2 Funding', dealName: 'Nasty C JV', amount: 1000000, direction: 'out', status: 'scheduled', date: 'Jun 1, 2026', counterparty: 'Nasty C JV', isoDate: '2026-06-01', category: 'investment', dealId: 'dj-deal-5', method: 'wire' },
    { id: 'dj-t-27', title: 'Africa Streaming Revenue', dealName: 'Nasty C JV', amount: 25000, direction: 'in', status: 'completed', date: 'Feb 28, 2026', counterparty: 'UMG', isoDate: '2026-02-28', category: 'royalties', dealId: 'dj-deal-5', method: 'ach' },
    { id: 'dj-t-28', title: 'Legal Setup Costs', dealName: 'Nasty C JV', amount: 75000, direction: 'out', status: 'completed', date: 'Dec 1, 2025', counterparty: 'Baker McKenzie', isoDate: '2025-12-01', category: 'legal', dealId: 'dj-deal-5', method: 'wire' },
  ],
};

export const ENTITY_CONNECTED_ACCOUNTS: Record<string, ConnectedAccount[]> = {
  'dj-pe-1': [
    { id: 'dj-ca-1', provider: 'plaid', label: 'Def Jam Operating', institution: 'JPMorgan Chase', lastFour: '8821', type: 'checking', status: 'active' },
    { id: 'dj-ca-2', provider: 'stripe', label: 'Merch Connect', institution: 'Stripe', lastFour: '3291', type: 'escrow', status: 'active' },
  ],
  'dj-pe-2': [
    { id: 'dj-ca-3', provider: 'plaid', label: 'UMG Distribution', institution: 'Citibank', lastFour: '5544', type: 'checking', status: 'active' },
  ],
  'dj-pe-3': [],
  'dj-pe-4': [
    { id: 'dj-ca-4', provider: 'plaid', label: 'Nasty C JV Account', institution: 'Standard Bank', lastFour: '2211', type: 'checking', status: 'active' },
  ],
};

export const ENTITY_ACTIVITY: Record<string, ActivityEntry[]> = {
  'dj-pe-1': [
    { id: 'dj-a-1', action: 'Deal updated', detail: 'Coco Jones recording deal moved to In Progress', date: '2 hours ago' },
    { id: 'dj-a-2', action: 'Payment sent', detail: 'Recording Advance Installment 1 — $833K to Coco Jones', date: '3 days ago' },
    { id: 'dj-a-3', action: 'Document uploaded', detail: 'Revised recording agreement v5 with territory carve-outs', date: '5 days ago' },
    { id: 'dj-a-4', action: 'Collaborator added', detail: 'Kecia Tatum joined Coco Jones recording deal', date: '1 week ago' },
    { id: 'dj-a-5', action: 'Payment received', detail: 'Q4 Streaming Royalties — $45K from UMG Distribution', date: '2 weeks ago' },
  ],
  'dj-pe-2': [
    { id: 'dj-a-6', action: 'Deal updated', detail: 'Bieber Album 7 Amendment moved to Signing', date: '3 hours ago' },
    { id: 'dj-a-7', action: 'Payment received', detail: 'Catalog Royalties Q4 — $1.2M from UMG', date: '5 days ago' },
    { id: 'dj-a-8', action: 'Document signed', detail: 'Jeff Harleston approved amendment terms', date: '1 week ago' },
  ],
  'dj-pe-3': [
    { id: 'dj-a-9', action: 'Deal created', detail: '2 Chainz Nike Sync License added to pipeline', date: '1 day ago' },
    { id: 'dj-a-11', action: 'Document uploaded', detail: 'Nike sync proposal uploaded by Sasha Robinson', date: '3 days ago' },
  ],
  'dj-pe-4': [
    { id: 'dj-a-12', action: 'Payment sent', detail: 'JV Initial Capitalization — $1M to Nasty C JV', date: '2 months ago' },
    { id: 'dj-a-13', action: 'Deal updated', detail: 'Nasty C JV progress to 50% — Nasty C team aligned on structure', date: '1 day ago' },
    { id: 'dj-a-14', action: 'Payment received', detail: 'Africa Streaming Revenue — $25K from UMG Africa', date: '3 weeks ago' },
  ],
};
